module.exports = __webpack_public_path__ + "static/media/9.1d7f7b5d.jpg";